<template>
  <q-list bordered class="q-pa-md q-pa-lg-lg bg-white more-rounded-borders" v-if="plan">
    <q-expansion-item v-model="expanded" header-class="text-bold" header-style="font-size: 20px"
                      icon="o_info" label="Need Help?">
      <q-card v-if="plan">

        <!--        <q-card-section>-->

        <!--          <property-section class="q-mt-md">-->
        <!--            <property-item label="Provider Name:" :value="name"></property-item>-->
        <!--            <property-item label="Address:" :value="address" v-if="address"></property-item>-->
        <!--            <property-item label="Email:" :value="support_email" v-if="support_email"></property-item>-->
        <!--            <property-item label="Website:" :value="website" v-if="support_email"></property-item>-->
        <!--            <property-item :label="`PUCT Certificate Number #${puct_number}`"></property-item>-->
        <!--          </property-section>-->

        <!--        </q-card-section>-->

        <q-card-section>
          <!--          <div class="text-100">-->
          <!--            For further assistance, feel free to call or email us.-->
          <!--          </div>-->

          <div class="flex justify-start q-gutter-y-md">
            <q-btn @click="call" :href="`tel:${plan_phone_number(plan)}`" no-wrap color="primary" unelevated no-caps
                   padding="10px 20px"
                   icon="phone" :label="plan_phone_number(plan)" class="q-pr-md text-bold rounded-borders-8 full-width">
            </q-btn>
            <!--            <q-btn color="primary" padding="10px 30px" icon="email" no-caps class="text-bold rounded-borders-8"-->
            <!--                   unelevated @click="get_help" label="Email Us">-->
            <!--            </q-btn>-->
            <q-btn color="primary" padding="10px 30px" icon="chat" no-caps
                   class="text-bold rounded-borders-8 full-width"
                   unelevated @click="chat" label="Chat With Us">
            </q-btn>
          </div>
        </q-card-section>
      </q-card>
    </q-expansion-item>
  </q-list>
</template>

<script>
import Utilities from "src/composables/Utilities";
import SelectedPlan from "src/composables/SelectedPlan";
import { ref } from "vue";
import PropertySection from "components/PropertySection";
import PropertyItem from "components/PropertyItem";
import Analytics from "src/composables/Analytics";
import Intercom from "src/composables/Intercom";

export default {
  name: "NeedHelpCard",
  components: { PropertyItem, PropertySection },
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  setup() {

    const { selected_plan } = SelectedPlan();
    const {
      plan_phone_number,
      plan_hours_string,
      plan_brand_puct,
      plan_brand_legal_name,
      plan_brand_address,
      plan_brand_support_email,
      plan_brand_website
    } = Utilities();
    const expanded = ref(true);
    const puct_number = plan_brand_puct(selected_plan.value);
    const address = plan_brand_address(selected_plan.value);
    const support_email = plan_brand_support_email(selected_plan.value);
    const website = plan_brand_website(selected_plan.value);
    const name = plan_brand_legal_name(selected_plan.value);

    const { log_event } = Analytics();
    const { call_intercom } = Intercom()

    const get_help = () => {
      log_event({ name: 'co_help_email' })
      window.open('mailto:support@comparepower.com')
    }

    const chat = () => {
      log_event({ name: 'co_help_chat' })
      call_intercom({ command: 'show' })

    }

    const call = () => {
      log_event({ name: 'co_help_phone' })
      window.open(`tel:${plan_phone_number(props.plan)}`)
    }

    return {
      expanded,
      plan_phone_number,
      plan_hours_string,

      name,
      puct_number,
      address,
      support_email,
      website,
      get_help,
      call,
      chat
    }
  }
}
</script>

<style scoped>

</style>
